import { Injectable } from '@angular/core';
import { combineLatest, BehaviorSubject } from 'rxjs';
import { take, map } from 'rxjs';
import { MfsUserCounts, MfsUserFilter, newUserPredicate, unconfirmedUserPredicate, liveUserPredicate, MfsUser } from '@feature/_app_modules/mojo-for-suppliers/user-admin/models/mfs-user';
import { UserAdminHttpService } from '@feature/_app_modules/mojo-for-suppliers/user-admin/services/user-admin-http.service';

@Injectable({
  providedIn: 'root'
})
export class UserAdminService {

  private users: MfsUser[];
  private currentFilter: MfsUserFilter = 'All';

  private usersSubject = new BehaviorSubject<MfsUser[]>([]);
  private filterSubject = new BehaviorSubject<MfsUserFilter>(this.currentFilter);


  getLimitedAccessConfig() {
    return this.userAdminHttp.getLimitedAccessConfig();
  }

  loadAllUsers() {
    this.userAdminHttp.getUsers().pipe(take(1)).subscribe(users => {
      this.users = users;
      this.usersSubject.next([...this.users]);
    },
      error => console.error('could not load users'));
  }

  getCurrentFilter() {
    return this.filterSubject.asObservable();
  }

  setFilter(filter: MfsUserFilter) {
    this.currentFilter = filter;
    this.filterSubject.next(this.currentFilter);
  }

  getUserCounts() {
    const filterAndUsers = combineLatest(this.usersSubject.asObservable(), this.getCurrentFilter());
    return filterAndUsers.pipe(map(([users, filter]) => {
      return {
        'All': users.length,
        'New': users.filter(newUserPredicate).length,
        'Unconfirmed': users.filter(unconfirmedUserPredicate).length,
        'Live': users.filter(liveUserPredicate).length,
      } as MfsUserCounts;
    })
    );
  }

  getUsers() {
    const filterAndUsers = combineLatest(this.usersSubject.asObservable(), this.getCurrentFilter());
    return filterAndUsers.pipe(map(([users, filter]) => {
      switch (filter) {
        case 'All':
          return users;
        case 'New':
          return users.filter(newUserPredicate);
        case 'Unconfirmed':
          return users.filter(unconfirmedUserPredicate);
        case 'Live':
          return users.filter(liveUserPredicate);
        default:
          return users;
      };
    }));
  }

  createUser(user: MfsUser) {
    return this.userAdminHttp.createUser(user);
  }

  updateUser(user: MfsUser) {
    return this.userAdminHttp.updateUser(user);
  }

  inviteUsers(users: MfsUser[]) {
    return this.userAdminHttp.inviteUsers(users);
  }

  deactivateUsers(users: MfsUser[]) {
    return this.userAdminHttp.deactivateUsers(users);
  }


  constructor(private readonly userAdminHttp: UserAdminHttpService) { }

}
